import React, { useState } from 'react';
import {
    TextField,
    IconButton,
    Menu,
    MenuItem,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const LaunchUrlField = ({
    url,
    label,
    helperText,
    onOpenTab,
    onOpenFrame
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenTab = () => {
        onOpenTab(url);
        handleClose();
    };

    return (
        <TextField
            fullWidth
            variant="outlined"
            value={url}
            label={label}
            helperText={helperText}
            InputProps={{
                endAdornment: (
                    <>
                        <IconButton onClick={handleClick}>
                            <OpenInNewIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleOpenTab}>
                                <OpenInNewIcon /> Open in New Tab
                            </MenuItem>
                        </Menu>
                    </>
                ),
            }}
        />
    );
};

export default LaunchUrlField;